import React from 'react';
import PropTypes from 'prop-types';

/**
 * Generates the close button for modals
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ModalCloseButton = props => {
	const {
		label,
		closeFunc
	} = props;

	return (
		<button type={'button'} className={'close'} onClick={() => closeFunc()}
		        aria-label={label} data-testid={'modal-close-button'}>
			<i className={'far fa-times'} aria-hidden="true"></i>
			{ label }
		</button>
	);
};

ModalCloseButton.propTypes = {
	label: PropTypes.string,
	closeFunc: PropTypes.func
};

export default ModalCloseButton;
